import React from "react";
import CategoryPage from "./CategoryPage";

const AcrylicLEDNameBoards = () => (
  <CategoryPage
    categoryId="acrylic-led-name-boards"
    categoryTitle="Acrylic LED Name Boards"
    categoryDescription="Illuminate your space with custom acrylic LED name boards. Perfect for bedrooms, offices, shops, and events. Features energy-efficient LED, multiple color options, and elegant designs."
  />
);

export default AcrylicLEDNameBoards;
